<template>
  <div id="modal_popup_loading" class="modal-popup">
    <div class="modal-popup-content">
      <img src="@/assets/images/loading.gif" />
      <p v-html="$t('loadingPopupMessage')"></p>
    </div>
  </div>

</template>

<script>
  export default {
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>